// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"664470b3","361":"5067f942","673":"1c0e51ab"}[chunkId] + ".chunk.js";
};